import { createFileRoute } from "@tanstack/react-router";
import { SettingsPage } from "src/components/views/settings/SettingsPage.tsx";

export const Route = createFileRoute("/_authenticated/settings")({
	component: SettingsPage,
});
